export default __webpack_public_path__ + "static/media/thumbnail.7608fc80.png";